module.exports = __webpack_public_path__ + "static/img/logo_L_size(china).3e8f3cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo_L_size(china).png
// module id = 78
// module chunks = 1